import { Link } from 'react-router-dom';

export default function FoerdernPage() {
  return (
    <div className="bg-white" style={{ fontFamily: 'Inter, -apple-system, sans-serif' }}>
      {/* Hero */}
      <section className="py-24 md:py-32 bg-gradient-to-b from-[#FAF9F7] to-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="max-w-3xl">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              Fördern
            </span>
            <h1 className="text-4xl md:text-[52px] font-bold text-gray-900 leading-tight tracking-tight mb-6">
              Förderung, die ankommt.
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              asK-mi macht Förderung transparent und wirkungsvoll. Wir bringen Förderer und Menschen zusammen – 
              und sorgen dafür, dass jeder Beitrag dort ankommt, wo er gebraucht wird.
            </p>
          </div>
        </div>
      </section>

      {/* Was wir fördern */}
      <section className="py-24 md:py-32">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              Förderbereiche
            </span>
            <h2 className="text-3xl md:text-[42px] font-bold text-gray-900 tracking-tight">
              Fünf Bereiche. Eine Mission.
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white border border-[#E8E4DE] rounded-2xl p-8 hover:border-[#C4A962] hover:shadow-lg transition-all duration-300">
              <div className="text-4xl mb-5">👤</div>
              <h3 className="font-bold text-xl text-gray-900 mb-3">Menschen</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Menschen, die Jugendliche und Familien begleiten – Mentoren, Begleiter, Fachkräfte.
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• Mentoring-Programme</li>
                <li>• Begleitungsprojekte</li>
                <li>• Fachkräfte-Förderung</li>
              </ul>
            </div>

            <div className="bg-white border border-[#E8E4DE] rounded-2xl p-8 hover:border-[#C4A962] hover:shadow-lg transition-all duration-300">
              <div className="text-4xl mb-5">🏛️</div>
              <h3 className="font-bold text-xl text-gray-900 mb-3">Einrichtungen</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Organisationen, die geeignete Unterstützungs- und Entwicklungsangebote schaffen.
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• Beratungsstellen</li>
                <li>• Bildungseinrichtungen</li>
                <li>• Therapiezentren</li>
              </ul>
            </div>

            <div className="bg-white border border-[#E8E4DE] rounded-2xl p-8 hover:border-[#C4A962] hover:shadow-lg transition-all duration-300">
              <div className="text-4xl mb-5">🏢</div>
              <h3 className="font-bold text-xl text-gray-900 mb-3">Unternehmen</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Unternehmen, die Jugendlichen Perspektiven, Praktika, Ausbildung oder Entwicklungsmöglichkeiten eröffnen.
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• Ausbildungsplätze</li>
                <li>• Praktika</li>
                <li>• Integrationsprogramme</li>
              </ul>
            </div>

            <div className="bg-white border border-[#E8E4DE] rounded-2xl p-8 hover:border-[#C4A962] hover:shadow-lg transition-all duration-300">
              <div className="text-4xl mb-5">🚀</div>
              <h3 className="font-bold text-xl text-gray-900 mb-3">Projekte</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Projekte, die neue Wege für Neurodiversität und gesellschaftliche Teilhabe entwickeln.
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• Pilotprojekte</li>
                <li>• Innovationsinitiativen</li>
                <li>• Gemeinschaftsprojekte</li>
              </ul>
            </div>

            <div className="bg-white border border-[#E8E4DE] rounded-2xl p-8 hover:border-[#C4A962] hover:shadow-lg transition-all duration-300">
              <div className="text-4xl mb-5">🔬</div>
              <h3 className="font-bold text-xl text-gray-900 mb-3">Forschung & Entwicklung</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Ansätze, die helfen, Neurodiversität besser zu verstehen und neue Möglichkeiten zu schaffen.
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• Studien</li>
                <li>• Forschungsprojekte</li>
                <li>• Methodenentwicklung</li>
              </ul>
            </div>

            <div className="bg-[#FAF9F7] border border-dashed border-[#E8E4DE] rounded-2xl p-8 flex flex-col justify-center items-center text-center">
              <p className="text-gray-500 mb-4">Sie haben ein Förderanliegen?</p>
              <Link 
                to="/kontakt"
                className="text-[#A8923F] font-medium hover:underline"
              >
                Kontaktieren Sie uns →
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Wirkung */}
      <section className="py-24 md:py-32 bg-[#FAF9F7]">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              Wirkung
            </span>
            <h2 className="text-3xl md:text-[42px] font-bold text-gray-900 tracking-tight">
              Was aus Förderung entstehen kann.
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { text: 'Ein Jugendlicher findet einen passenden Ausbildungsplatz.', label: 'Perspektive' },
              { text: 'Eine Familie erhält die Unterstützung, die sie braucht.', label: 'Entlastung' },
              { text: 'Eine Einrichtung kann ein neues Angebot schaffen.', label: 'Entwicklung' },
              { text: 'Ein Unternehmen öffnet eine neue Perspektive.', label: 'Chance' },
              { text: 'Ein Projekt kann endlich umgesetzt werden.', label: 'Umsetzung' },
              { text: 'Neue Forschung kann entstehen und wirken.', label: 'Erkenntnis' },
            ].map((item, i) => (
              <div 
                key={i}
                className="bg-white rounded-xl p-8 border-l-4 border-[#C4A962] hover:shadow-md transition-all duration-300"
              >
                <p className="text-gray-900 italic leading-relaxed mb-4">„{item.text}"</p>
                <p className="text-xs font-semibold text-[#A8923F] uppercase tracking-wider">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32 bg-gray-900 text-white text-center">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <h2 className="text-3xl md:text-[48px] font-bold tracking-tight mb-6 leading-tight">
            Potenzial erkennen.<br />Zukunft ermöglichen.
          </h2>
          <p className="text-lg text-white/70 max-w-xl mx-auto mb-10">
            Werden Sie Förderer und ermöglichen Sie jungen Menschen neue Perspektiven.
          </p>
          <Link 
            to="/foerderer-werden"
            className="inline-flex items-center gap-2 bg-[#C4A962] hover:bg-[#D4B972] text-gray-900 px-9 py-4 rounded-md font-semibold text-lg transition-all hover:-translate-y-0.5"
          >
            Förderer werden
          </Link>
        </div>
      </section>
    </div>
  );
}
